import { ROUTES } from '@/constants'
import { dateHelper } from '@/helpers/dateHelper'
import { i18n } from '@/plugins/i18n'
import CollectService from '@/services/collect/collectService'
import { SET_IS_LOADING_APP, SET_LANGUAGE } from '@/store/mutation-types'
import { ClientPage, Collect, HeaderContent } from '@/types'
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    availableLanguages: [] as string[],
    clientPage: null as ClientPage | null,
    headerData: null as HeaderContent | null,
    collect: null as Collect | null,
    language: null as string | null,
  }),
  methods: {
    async getCollect(type: string, language?: string): Promise<void> {
      try {
        const {
          params: { id },
        } = this.$route

        if (!language) {
          language = this.$store.getters.language
        }

        this.language = language || null

        const { collect, languages, pages } = await CollectService.getCollect(id, type, language)

        const {
          retailerLogo,
          externalCollectId,
          createdAt,
          customer: { timezone },
        } = collect
        this.headerData = {
          retailerLogo,
          referenceNumber: externalCollectId,
          createdAt,
          timezone,
        }

        this.clientPage = pages[0]
        this.collect = collect

        if (languages) {
          this.availableLanguages = languages!
          this.$root.$i18n.i18next.language = this.clientPage!.language

          i18n.changeLanguage(this.clientPage!.language)
          dateHelper.changeLocale(this.clientPage!.language)
          // This force update of i18n system to allow the use of this.$t in methods and computeds
          this.$root.$i18n.i18nLoadedAt = dateHelper.getDate().toString()

          this.$store.commit(SET_LANGUAGE, this.clientPage!.language)
        }

        if (!languages.includes(language)) {
          this.$store.commit(SET_LANGUAGE, this.clientPage!.language)
        }

        this.$store.commit(SET_IS_LOADING_APP, false)
      } catch (e) {
        this.$router.push({ name: ROUTES.NOT_FOUND })
      }

      return
    },
  },
})
